/** Role → visible outcome groups map for the Services catalogue.
 *  Suntronix internal roles and customer_admin see every outcome. Domain
 *  roles see the outcomes they actually initiate day-to-day. */
export const ALL_GROUPS = [
  "get_technology", "deploy", "move", "support", "store",
  "recover", "reuse", "retire", "manage", "plan", "premium",
];

const HR_GROUPS         = ["deploy", "move", "recover", "manage"];
const IT_GROUPS         = ["deploy", "support", "recover", "plan", "manage", "get_technology"];
const PROC_GROUPS       = ["get_technology", "plan", "manage"];
const FINANCE_GROUPS    = ["plan", "manage"];
const EMPLOYEE_GROUPS   = ["deploy", "support"];
const EXEC_GROUPS       = ["premium", "deploy", "support", "get_technology"];

const ROLE_GROUPS = {
  // Customer-side domain roles
  customer_hr:          HR_GROUPS,
  customer_it:          IT_GROUPS,
  customer_procurement: PROC_GROUPS,
  customer_finance:     FINANCE_GROUPS,
  employee_user:        EMPLOYEE_GROUPS,
  executive:            EXEC_GROUPS,
  // customer_admin & customer_user see everything by default
};

/**
 * Return the outcome groups visible for a given user.
 * Suntronix staff and super/customer admins see every group.
 * Domain roles see their scoped subset. Unknown roles fall back to all.
 */
export function allowedGroupsForUser(user) {
  if (!user) return ALL_GROUPS;
  // Suntronix internal: no master_company_id
  if (!user.master_company_id) return ALL_GROUPS;
  const role = (user.role || "").toLowerCase();
  if (role === "super_admin" || role === "customer_admin" || role === "admin") return ALL_GROUPS;
  return ROLE_GROUPS[role] || ALL_GROUPS;
}
